/**
 * common data for controllers hierarchy
 */

/**
 * commonDataFactory
 * returns commonDataFactory structure
 *
 * @class commonDataFactory
 * @memberof mwApp/common
 * @see mwApp/common
 *
 * @ngdoc factory
 * @name mwApp/common.factory:commonDataFactory
 */
/* @ngInject */
export default function commonDataFactory () {
  return {
    data: {

      /**
       * Last template id for report templates (ReportTemplatesCtrl)
       *
       * @type {Number}
       */
      lastTemplate: 0,

      /**
       * Last report id for generated reports (GeneratedReportsCtrl)
       *
       * @type {Number}
       */
      lastReport: 0,

      /**
       * Method for update property
       *
       * @param prop
       * @param value
       * @name mwApp/common.mixin:commonDataFactory
       */
      update: function (prop, value) {
        if (this.hasOwnProperty(prop)) {
          this[prop] = value || 0
        }
      }
    }
  }
}
